import { axiosOpen } from "../api/axios";

const convertDate = (args) => {
  if (args) {
    const dt = args.split("T")[0];
    const date = new Date(dt).getUTCDate();
    const month = new Date(dt).getUTCMonth() + 1;
    const year = new Date(dt).getUTCFullYear();
    return `${date}-${month}-${year}`;
  } else {
    return "";
  }
};


const getOptimizedData = async (requestBody, userID) => {
  try {
    const response = await axiosOpen.post(`amazon/getAnalyzedData/${userID}`, {
      ...requestBody,
    });
    return response.data

  } catch (error) {
    handleApiError(error);
  }

}

const deleteOptiizedData = async (promptID) => {
  const response = await axiosOpen.delete(`prompt/deleteprompt/${promptID}`);
  return response;
}


const handleApiError = (error) => {
  if (error.response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    console.log("Response error:", error.response.data);
  } else if (error.request) {
    // The request was made but no response was received
    console.log("Request error:", error.request);
  } else {
    // Something happened in setting up the request that triggered an Error
    console.log("Error:", error.message);
  }
};
export { convertDate, getOptimizedData, deleteOptiizedData };
